import type { ImageWidget } from "~/types/widgets"

import Image from "~/components/ui/Image"

export interface Props {
  /**
   * @title Logo da marca
   * @description Preferencialmente usar formato SVG
   */
  logo: ImageWidget

  /**
   * @title Texto Alternativo do Logo
   */
  alt: string

  /**
   * @title Texto SEO - Desktop
   */
  seoDesktop: string

  /**
   * @title Texto SEO - Mobile
   * @description Se não for inserido um texto SEO para mobile, será renderizado o texto cadastrado no desktop
   */
  seoMobile?: string

  /**
   * @title Cor do texto
   * @format color
   */
  colorText?: string

  /**
   * @title Cor do fundo
   * @format color
   */
  colorBackground?: string
}

export default function BrandSeoTop(
  { logo, alt, seoDesktop, seoMobile, colorText, colorBackground, isMobile }: Awaited<
    ReturnType<typeof loader>
  >,
) {
  if (!logo || !alt || !seoDesktop || !seoMobile) return null

  return (
    <div className='w-full max-w-[1834px] mt-3 mx-auto px-4'>
      <a
        href='#brand-seo'
        className='w-full flex items-center px-5 py-3 rounded-xl gap-5 md:gap-10'
        style={{ backgroundColor: colorBackground }}
      >
        <h1 className='w-full min-w-[86px] md:min-w-[100px] max-w-[86px] md:max-w-[100px]' title={alt}>
          <Image
            src={logo}
            className='w-full h-full object-cover'
            width={isMobile ? 86 : 100}
            height={isMobile ? 50 : 58}
            alt={alt}
          />
        </h1>

        <div
          className='flex min-h-[54px] md:min-h-11 w-[1px] min-w-[1px]'
          style={{ backgroundColor: colorText }}
        />

        <p className='text-sm md:text-base line-clamp-3' style={{ color: colorText }}>
          {!isMobile ? seoDesktop : seoMobile}
        </p>
      </a>
    </div>
  )
}

export const loader = (props: Props & { isMobile?: boolean }) => {
  const colorText = props.colorText ?? '#333333'
  const colorBackground = props.colorBackground ?? '#F5F5F5'
  const seoMobile = props.seoMobile ?? props.seoDesktop

  const isMobile = props.isMobile ?? false

  return { ...props, colorText, colorBackground, seoMobile, isMobile }
}
